import { defineComponent as _defineComponent } from 'vue'
import { FullColorObject } from '@/composables/color';
import { Ref, computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlphaSlider',
  props: {
    colors: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'change', value: Partial<FullColorObject>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    colors: FullColorObject;
};





const containerRef: Ref<HTMLDivElement | null> = ref(null);

const gradientColor = computed(() => {
    const rgb = props.colors.rgb;
    const rgbStr = [rgb.r, rgb.g, rgb.b].join(',');
    return 'linear-gradient(to right, rgba(' + rgbStr + ', 0) 0%, rgba(' + rgbStr + ', 1) 100%)';
});

const handleChange = (e: MouseEvent | TouchEvent) => {
    e.preventDefault();

    const container = containerRef.value;

    // for some edge cases, container may not exist
    if (!container) return;

    const containerWidth = container.clientWidth;

    const xOffset = container.getBoundingClientRect().left + window.scrollX;
    const pageX = (e as MouseEvent).pageX || ((e as TouchEvent).touches ? (e as TouchEvent).touches[0].pageX : 0);
    const left = pageX - xOffset;

    let alpha;
    if (left < 0) {
        alpha = 0;
    } else if (left > containerWidth) {
        alpha = 1;
    } else {
        alpha = Math.round((left * 100) / containerWidth) / 100;
    }

    if (props.colors.a !== alpha) {
        emit('change', {
            hsl: { ...props.colors.hsl },
            a: alpha
        });
    }
};

const handleMouseUp = () => {
    unbindEventListeners();
};

const handleMouseDown = () => {
    window.addEventListener('mousemove', handleChange);
    window.addEventListener('mouseup', handleMouseUp);
};

const unbindEventListeners = () => {
    window.removeEventListener('mousemove', handleChange);
    window.removeEventListener('mouseup', handleMouseUp);
};

return { __sfc: true,props, emit, containerRef, gradientColor, handleChange, handleMouseUp, handleMouseDown, unbindEventListeners }
}

})